module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAIVBMVEX////Pt8F4Mk1tIT+7l6XTvcZ7NlG/nqtxJ0TXw8vDpLGHW34mAAAAWUlEQVR4AWJABozKxoSBAQMqcCZdCwNrMqBdOqYBGIphKOi1jAOpMD8GD94OwFOk+OokuT7J1yfJv79y+4+Vu/TrAwPMMgEGGGCAAQYYYIABBhhggAEGGGAeNMSnV1DYz1sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/qatar.png
// module id = 636
// module chunks = 0